import { useState } from "react";
import Reveal from "./Reveal";

const faqs = [
  {
    q: "「来龙去脉」和普通的八卦爆料有什么区别？",
    a: "普通爆料往往只呈现单点碎片，容易断章取义、引发反转。而我们的事件梳理，会完整还原事件的前因后果：从最早的信源、关键时间节点、各方回应，到后续进展，帮助你看清一件瓜事的完整结构与真实脉络，而不只停留在情绪层面。",
  },
  {
    q: "你们的「事件时间线」是怎么做出来的？",
    a: "编辑团队会多渠道交叉核实信息源，按时间顺序整理出可追溯的关键节点，并为每个节点标注其性质（事实、回应、猜测等）。我们会区分「已证实」与「待核实」，尽可能避免把未经证实的猜测写成既定事实。",
  },
  {
    q: "事件还在反转中，档案会及时更新吗？",
    a: "会的。对于「热度持续」或「多方博弈」的进行中事件，我们会持续追踪并滚动更新时间线，补充新的回应与进展节点。读者重新打开档案，就能看到事件最新的来龙去脉。",
  },
  {
    q: "我有一条线索想投稿，你们如何核实？",
    a: "你可以通过页面底部或导航栏的「投稿线索」入口提交。收到后我们会先做基础事实核查与信源比对，确认信息完整可靠后才会整理入库。为保护投稿人，我们不会公开你的个人信息。",
  },
  {
    q: "「吃瓜档案库」可以按分类或关键词查找吗？",
    a: "可以。档案库支持按娱乐圈、网络热点、商业圈、社会议题等分类筛选，也支持输入关键词进行全文搜索，方便你快速定位感兴趣的事件并查看完整来龙去脉。",
  },
  {
    q: "网站内容会不会出现立场偏颇或不实信息？",
    a: "我们坚持以「还原事实、平衡呈现」为内容原则。梳理事件时会尽量呈现多方视角，并对不确定信息明确标注。如果你发现档案存在偏差或遗漏，欢迎通过投稿与反馈通道告诉我们，我们会及时复核修正。",
  },
];

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="guide" className="bg-background-50 py-16 md:py-24">
      <div className="section-wrap grid grid-cols-1 gap-10 lg:grid-cols-[0.9fr_1.1fr]">
        <Reveal>
          <div className="lg:sticky lg:top-36">
            <p className="flex items-center gap-2 text-sm font-medium text-primary-700">
              <span className="h-px w-6 bg-primary-600"></span> FAQ · 吃瓜指南
            </p>
            <h2 className="font-serif-editorial mt-3 text-3xl font-black text-foreground-950 md:text-4xl">
              常见问题与
              <br />
              吃瓜指南
            </h2>
            <p className="mt-5 leading-8 text-foreground-600">
              关于站点的内容原则、事件梳理方式与投稿流程，这里都有答案。理性吃瓜、看懂门道，
              是我们想传达给你的态度。
            </p>
            <div className="mt-8 rounded-2xl border border-accent-200 bg-accent-50 p-5">
              <p className="flex items-center gap-2 font-medium text-accent-900">
                <i className="ri-account-circle-line text-lg"></i>
                还有其他疑问？
              </p>
              <p className="mt-1 text-sm text-accent-800">
                欢迎到页脚「投稿线索」留言，或通过意见反馈与我们联系。
              </p>
            </div>
          </div>
        </Reveal>

        <div className="flex flex-col gap-3">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <Reveal key={i} delay={i * 40}>
                <div
                  className={`overflow-hidden rounded-2xl border transition-colors ${
                    open ? "border-primary-300 bg-background-50" : "border-background-200 bg-background-100"
                  }`}
                >
                  <button
                    onClick={() => setOpenIdx(open ? null : i)}
                    className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                    aria-expanded={open}
                  >
                    <h3 className="text-base font-bold leading-snug text-foreground-900 md:text-lg">
                      {f.q}
                    </h3>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                        open ? "bg-primary-600 text-white" : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      <i className={open ? "ri-subtract-line" : "ri-add-line"}></i>
                    </span>
                  </button>
                  <div
                    className="grid transition-all duration-300"
                    style={{ gridTemplateRows: open ? "1fr" : "0fr" }}
                  >
                    <div className="overflow-hidden">
                      <p className="px-6 pb-6 text-sm leading-7 text-foreground-700 md:text-[15px]">
                        {f.a}
                      </p>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}